import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type FormatPeriodFilter = (
  input: Date,
  periodTypeValue: string,
) => string;

interface IFormatPeriod {
  transform: FormatPeriodFilter;
}

/**
 * Filter which normalizes date formats according to periodTypeValue.
 * @param {input: Date}
 * Date to be normalized
 * If input is undefined the filter will fail silently
 * @param {periodTypeValue: string}
 * Defines the interval for which the filter is applied
 * @return {string} returns formatted date as a string
 */
@Pipe({ name: 'formatPeriod' })
export class FormatPeriodPipe implements PipeTransform, IFormatPeriod {
  constructor(
    private amDateFormatFilter,
    private translateFilter,
  ) {
    'ngInject';
  }

  public transform(input: Date, periodTypeValue: string): string {
    if (!input) {
      return;
    }

    switch (periodTypeValue) {
      case 'day':
        return this.amDateFormatFilter(input, 'dd L');
      case 'week':
        return (
          this.amDateFormatFilter(input, 'gggg ') +
          this.translateFilter('core.week') +
          this.amDateFormatFilter(input, ' w')
        );
      case 'month':
        return this.amDateFormatFilter(input, 'MMM YYYY');
      case 'quarter':
        return (
          this.amDateFormatFilter(input, 'YYYY ') +
          this.translateFilter('core.quarter') +
          this.amDateFormatFilter(input, ' Q')
        );
      case 'year':
        return this.amDateFormatFilter(input, 'YYYY');
    }
  }
}
